// Core
import React from 'react';
import { Box, Button, Flex, Text, Divider, Grid, Image, useColorMode } from '@chakra-ui/react';

// Assets
import { ReactComponent as Lines } from 'assets/svg/lines.svg';
import { ReactComponent as LinesWhite } from 'assets/svg/lines-white.svg';
import crystal from 'assets/img/details/crystal-3.png';

// Components
import Card from 'components/Card/Card';
import Li from 'components/Lists/List';

const WhatIs = () => {
	const { colorMode } = useColorMode();
    const isDark = colorMode === 'dark';

    return (
    	<Box pt="100px" mt="-100px" overflow="hidden" borderRadius="16px">
	        <Card padding="0px">
	        	<Grid templateColumns={{ sm: '1fr', lg: '1fr 1fr' }} gap="0px" templateRows='1fr' overflow="hidden">
	        		<Box overflow={{base: 'visible', lg: 'hidden'}} position="relative" zIndex="2">
	        			<Box p="1px 16px 27px 16px" zIndex="2" position="relative" w={{base: '100%', md: '50%', lg: '100%'}}>
			        		<Li text="LMCT+ is Australia’s biggest rewards club, while LUXE+ is the largest luxury rewards club. We help businesses like yours attract new customers by offering exclusive discounts and privileges to 2 million+ Aussies." />
	        				<Li text="Our customers get to save hundreds from shopping with our partners and those businesses get extra exposure to our customers." />
	        			</Box>

	        			<Box 
				          display={{base: 'block', lg: 'none'}}
				          top="0px"
				          bg={ isDark ? '#00071C' : '#dfe9fd'}  zIndex="-1" filter="blur(110px)" borderRadius="100%" w={{base: '100%', md: '80%', lg: 'unset'}} h="290px" position="absolute" />
	        		</Box>

	        		<Box mt={{base: '100px', md: 'unset'}} zIndex="1" className="animation-what-bap">
	        			<Box overflow="hidden" h="100%" position="absolute" w="100%" left="0">
	        				{ isDark ?
	        				<Lines className="abstract-lines" style={{ zIndex: 1, top: '-220%', transform: 'rotate(-201deg) scale(1)', left: '17%' }} />
	        				:
	        				<LinesWhite className="abstract-lines" style={{ zIndex: 1, top: '-220%', transform: 'rotate(-201deg) scale(1)', left: '17%', opacity: 0.3 }} />
	        				}
	        			</Box>
	        			<Box mt="0px" borderRadius="16px" overflow="hidden" position="relative" w="200%" h="100%" right="100%">
	        				{ isDark && <Box className="animation-what-bap-gradient" bg="#099BFF" zIndex="0" filter="blur(100px)" borderRadius="100%" m="0 auto" w="35%" right="10px" top="40px" h="270px" position="absolute" />}
	        			</Box>
	        			<Image className="animation-what-bap-crystal1" src={crystal} alt="crystal" position="absolute" w="360px" right="0px" bottom="0px" transform="rotate(360deg)" zIndex="2" />
	        			<Image className="animation-what-bap-crystal2" src={crystal} alt="crystal" position="absolute" w="260px" right="-30px" bottom="-58px" transform="rotate(390deg)" zIndex="2" />
	        			<Image className="animation-what-bap-crystal3" src={crystal} alt="crystal" position="absolute" w="235px" right="108px" transform="rotate(-20deg)" bottom="-83px" zIndex="2" />
	        			<Image className="animation-what-bap-crystal4" src={crystal} alt="crystal" position="absolute" w="238px" right="226px" transform="rotate(-19deg)" bottom="-59px" zIndex="2" />
	        			<Image className="animation-what-bap-crystal5" src={crystal} alt="crystal" position="absolute" w="138px" right="8px" transform="rotate(42deg)" bottom="50px" zIndex="1" />
	        			<Image className="animation-what-bap-crystal6" src={crystal} alt="crystal" position="absolute" w="80px" right="305px" transform="rotate(-30deg)" bottom="101px" zIndex="2" />
	        			<Image className="animation-what-bap-crystal7" src={crystal} alt="crystal" position="absolute" w="100px" right="403px" transform="rotate(25deg)" bottom="6px" zIndex="2" />
	        		</Box>
	        	</Grid>
	        </Card>
        </Box>
    );
};


export default WhatIs;